import { useState, useLayoutEffect } from 'react'

function useContainerWidth(domRef) {
  // 监听屏幕尺寸
  const [width, setWidth] = useState(0)
  useLayoutEffect(() => {
    function updateSize() {
      setWidth(domRef.current?.getBoundingClientRect?.()?.width || window.innerWidth)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [domRef.current])

  return width
}

export default useContainerWidth
